export const getGlobalStartDate = (state) => state.global.globalPeriod.globalStartDate;
export const getGlobalEndDate = (state) => state.global.globalPeriod.globalEndDate;
